export const ENV_ALERT_GREEN = '#aef023';
export const ENV_ALERT_PINK = '#ff4a99';
export const ENV_ALERT_YELLOW = '#fff200';
